module.exports = __webpack_public_path__ + "files/6c39c139f9e4141008af3aa1159fe2fa.png";